

import React, { Component } from 'react';

// Externals
import compose from 'recompose/compose';
import Highcharts from 'highcharts/highstock'
import HighchartsReact from 'highcharts-react-official'

// Material helpers
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import { withRouter } from 'react-router-dom';

import {getEvents} from '../../../../../../services/getEvents';

// Custom components
import CircularProgress from '@material-ui/core/CircularProgress';

// Material components
import Typography from '@material-ui/core/Typography';

// Component styles
import styles from './styles';
import moment from 'moment'
import 'moment/locale/es'
moment.locale('es')


class DistributionIsp extends Component {
    constructor(props) {
        super(props);
        //console.log('dc', props)
        this.state = {
            node:this.props.data.node,
            objective:this.props.match.params,
            step:this.props.data.step,
            dateBegin:this.props.data.range.startDate,
            finalDate:this.props.data.range.endDate,
            isLoad:true,
            error:false,
        };
    }
    componentDidMount() {
        this.getData()
    }

    static getDerivedStateFromProps(props, state) {
        //console.log('derived', moment(props.data.range.startDate).format("Y-MM-DD"), moment(state.dateBegin).format("Y-MM-DD"))
        //console.log(props.data.range.endDate,state.finalDate)
        if(props.data.step.id_paso!==state.step.id_paso){
            return{
                step:props.data.step,
                isLoad:true,
            }
        }
        if( moment(props.data.range.startDate).format("Y-MM-DD")!==moment(state.dateBegin).format("Y-MM-DD")){
            return{
                dateBegin:props.data.range.startDate,
                finalDate:props.data.range.endDate,
                isLoad:true,
            }    
        }
        return null
    }

    componentDidUpdate(prevProps, prevState) {
        //console.log(moment(prevProps.data.range.startDate).format("Y-MM-DD"),moment(this.state.dateBegin).format("Y-MM-DD"))
        if(prevProps.data.step.id_paso!== this.state.step.id_paso
            ||moment(prevProps.data.range.startDate).format("Y-MM-DD")!==moment(this.state.dateBegin).format("Y-MM-DD")
            ){
            this.getData()
        }
    }

    getData=()=>{
        //console.log('get',this.state)
        const {dateBegin, finalDate,objective,node}=this.state
        //console.log(dateBegin, finalDate, objective, node)
        let token = sessionStorage.getItem('key')
        let user = sessionStorage.getItem('user')
        //console.log(objective)
        //console.log(dateBegin)
        var fecha_inicio=moment(dateBegin).format("Y-MM-DD HH:mm")
        var fecha_termino=moment(finalDate).format("Y-MM-DD HH:mm")
        //console.log(fecha_inicio, fecha_termino)
        getEvents(user, objective.objetivo_id, fecha_inicio, fecha_termino, token).then(Events=>{
            if (Events.status == 1 || Events.status == 5) {
                localStorage.setItem('isAuthenticated', false);
            } else {
                //Procesa la Data Recibida
                try {
                    this.processData(Events)
                } catch (error) {                     
                    this.setState({
                        error: true,
                        isLoad: false
                    });
                }
            }
        })
        
    }

    processData=(data)=>{
        //console.log(data)
        const {step}=this.state
        //console.log('step', step)
        var listIsps=[]
        var contError=0
        data.map(isp=>{
            //console.log(isp.nombre_nodo)
            //var timeNodeUp=0
            var timeNodeDown=0
            isp.data_nodo.map(eventos=>{
                eventos.map(evento=>{
                    let dateHasta = (new Date(evento.hasta))
                    let dateDesde = (new Date(evento.desde))
                    let result = dateHasta - dateDesde
                    var status=((evento.pasos.filter(paso=>paso.id===step.id_paso))[0].estado)
                    if(parseInt(status)!==0){
                        timeNodeDown+=result
                    }
                })
            })
            contError+=timeNodeDown
            listIsps.push({'name':isp.nombre_nodo, 'y':timeNodeDown})
        })
        var factor=100/contError
        //console.log(listIsps)
        listIsps.map(isp=>{
            //console.log(isp.y)
            if(isp["y"]!==0){
                isp.y=parseFloat((isp.y*factor).toFixed(2))
            }
        })
        //console.log(listIsps)
        this.setState({
            chartOptions: {
                colors: ['#50B432', '#ED561B', '#DDDF00', '#24CBE5', '#64E572', '#FF9655', '#FFF263','#6AF9C4'],
                chart: {
                    type: 'pie',
                    options3d: {
                        enabled: true,
                        alpha: 45,
                        beta: 0
                    }
                },
                credits: {
                    enabled: false
                },
                title: {
                    text: "Disponibilidad Entre Isps",
                    style: {
                        color: '',
                        fontWeight: '',
                        fontSize: '' 
                    }
                },
                accessibility: {
                    point: {
                        valueSuffix: '%'
                    }
                },
                tooltip: {
                    pointFormat: '<b>{point.percentage:.1f}%</b>'
                },
                plotOptions: {
                    pie: {
                        allowPointSelect: true,
                        cursor: 'pointer',
                        depth: 35,
                        dataLabels: {
                            enabled: true,
                            format: '{point.percentage:.2f}'
                        },
                        showInLegend: true
                    }
                },
                series: [{
                    type: 'pie',
                    data: listIsps
                }]
            },
            isLoad: false,
        });    
    }

    render() {
        
        const {isLoad, error,chartOptions,step}=this.state
        
        if(error!==true){
            if (isLoad===true) {
                //console.log('vista rapida render carga')
                return(
                    <Grid
                        container
                        spacing={1}
                    >
                        <Grid
                            item
                            xs={6}
                            sm={6}
                            md={6}
                            xl={6}
                            style={{textAlign:"right"}}    
                        >
                            <CircularProgress variant="indeterminate" size={24} thickness={4} />
                        </Grid>
                        <Grid
                            item
                            xs={6}
                            sm={6}
                            md={6}
                            xl={6}
                        >
                            <Typography variant="h5" color="primary" style={{color:"#525252"}}> Cargando Información...</Typography>
                        </Grid>
                    </Grid>
                )
            }else{
                //console.log('render graph')
                sessionStorage.setItem("chartDistributionIsp"+String(step.id_paso),JSON.stringify(chartOptions))
                return(
                        <Grid
                            item
                            xs={6}
                            sm={6}
                            md={6}
                            xl={6}
                        >
                            <HighchartsReact
                                highcharts={Highcharts}
                                options={this.state.chartOptions}
                            />
                        </Grid>
                    )
            }   
        }else{
            return(<div>error</div>)
        }
    }
}



export default
    compose(withRouter, withStyles(styles))(DistributionIsp);